import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import NotificationsButtonQuery, {
	type NotificationsButtonQuery$data,
	type NotificationsButtonQuery$variables,
} from './__generated__/NotificationsButtonQuery.graphql.ts';

export const preloadUnseenNotificationCount = (): Promise<{
	data: NotificationsButtonQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return queryAgg<NotificationsButtonQuery$data, NotificationsButtonQuery$variables>({
		query: NotificationsButtonQuery,
	});
};
